<vb-confirmation-dialog [title]="'Error' | translate" [message]="'Event_UnableToControlAutomatedWebcastManually' | translate" [actionText]="'Ok' | translate">
</vb-confirmation-dialog>

<div flex-align="center" flex-justify="end" layout-gt-md-wrap="false" layout="row" [ngClass]="styles.wrapper">
	<h2 flex="fill" [ngClass]="styles.title" [hidden]="webcast.currentUser.isEventAdmin" title="{{webcast.title }}">
		{{ webcast.title }}
	</h2>

	<div *ngIf="webcast.currentUser.isSinglePresenter && webcast.webcastStatus.isStarted" [ngClass]="styles.statusLabel">
		<span [ngClass]="(webcast.webcastStatus.isInProgress || webcast.webcastStatus.isBroadcasting) ? styles.warn : ''">
			{{ getPresenterLabel() | translate }}
		</span>
	</div>

	<div *ngIf="producerStatus.isLive || producerStatus.isBackstage" [ngClass]="styles.statusLabel"> {{
			(producerStatus.isLive ?
				(webcast.broadcast.isActive ? 'Event_Producer_YouAreBroadcasting' : 'Event_Producer_YouAreQueuedNoBroadcast') :
				webcast.broadcast.isActive ? 'Event_Producer_YouAreQueued' : '') | translate
	}}
	</div>

	<div [ngClass]="styles.webcastButtons">
		<div class="btn-group" *ngIf="showPresenterReadyToggle()">
			<div [ngClass]="styles.presenterReady">
				<label for="presenterReady" [ngClass]="{'text-white': !webcast.isPresenterReady}">
					{{ "Event_NotReady" | translate }}</label>
				<vb-toggle-button [toggleId]="'presenterReady'" [(ngModel)]="webcast.isPresenterReady" [ariaLabel]="'Event_PresenterReady' | translate" (ngModelChange)="onPresenterReadyChange()" [disabled]="disablePresenterReady">
				</vb-toggle-button>
				<label [ngClass]="{'text-white': webcast.isPresenterReady}">
					{{ "Event_Ready" | translate }}</label>
			</div>
		</div>

		<a *ngIf="webcastViewContext?.showCloseBtn" class="glyphicons remove_2" [attr.aria-label]="Close | translate" (click)="goToPreviousState()" vbBtnPrimary>
		</a>

		<!--Toggle Visibility of Regions-->
		<webcast-region-visibility-toggle *ngIf="!webcast.currentUser.isSinglePresenter && !webcast.currentUser.isPresenter" [ngClass]="styles.webcastRegionVisibilityToggle" [hidden]="!webcast.layout.displayLayoutControls" [webcast]="webcast">
		</webcast-region-visibility-toggle>

		<!--Toggle View-->
		<div [hidden]="!webcast.layout.canToggleView" class="btn-group">
			<button type="button" [ngClass]="[
					styles.webcastNavBtn,
					styles.webcastNavToggleViewBtn
				]" [disabled]="!webcast.layout.isVideoVisible || !webcast.layout.isPresentationVisible" (click)="toggleLayout()" vbBtnSecondary [inactive]="!webcast.layout.isVertical">
				{{ 'Event_ToggleLayout' | translate }}
			</button>
		</div>

		<!-- Record -->
		<div *ngIf="webcast.isRecordingAllowed() && webcast.currentUser.isEventAdmin" class="btn-group">
			<webcast-recording-button [webcast]="webcast">
			</webcast-recording-button>
		</div>

		<!-- Webcast State Controls -->
		<div [ngClass]="styles.webcastStateControls" class="btn-group" *ngIf="webcast.currentUser.isEventAdmin">

			<!--End-->
			<button *ngIf="webcast.currentUser.canControlEventStatus && !webcast.webcastStatus.isEnded" [disabled]="webcast.broadcast.isStopping || webcast.broadcast.isStarting" [ngClass]="styles.webcastNavBtn" type="button" vbBtnSecondary (click)="endEvent()">

				<span [hidden]="!webcast.currentRun.isMainEvent">
					{{ 'Event_EndEvent' | translate }}
				</span>
				<span [hidden]="!webcast.currentRun.isPreProduction">
					{{ 'Event_EndPreProduction' | translate }}
				</span>
			</button>

			<!--Broadcast controls -->
			<webcast-broadcast-button [webcast]="webcast" [hidden]="webcast.isAutomated ||
					webcast.isProducerEvent && (!webcast.currentUser.isAssignedEventAdmin || isMobile)">
			</webcast-broadcast-button>

			<!-- Manual Control (automated webcast) -->
			<button *ngIf="webcast.isAutomated && webcast.currentRun.isMainEvent && webcast.currentRun.isStarted" [ngClass]="styles.webcastNavBtn" type="button" vbBtnSecondary (click)="cancelAutomatedWebcast()">
				{{ 'Event_ManualControlAutomatedWebcast' | translate }}
			</button>

		</div>
	</div>
</div>
